import { NavLink } from 'react-router-dom';

const style = {
  display: 'block',
  textDecoration: 'none',
  marginBottom: '2rem',
  color: '#888888',
  fontSize: '1.6rem',
};

export type BackLinkProps = Readonly<{
  link: string;
  label: string;
}>;

const BackLink = (props: BackLinkProps) =>
  <NavLink to={props.link} css={style}>← {props.label}</NavLink>;

export default BackLink;
